/* eslint "jsx-a11y/no-static-element-interactions": "off" */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';
import cx from 'classnames';
import Collapsible from 'components/common/controls/Collapsible';

const propTypes = {
  children: PropTypes.any,
  title: PropTypes.element,
  mod: PropTypes.string,
  color: PropTypes.string,
  alignment: PropTypes.string,
  defaultOpened: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  isDisabled: PropTypes.bool,
  forceOpen: PropTypes.bool,
  iconName: PropTypes.string,
  asBlock: PropTypes.bool,
  withPadding: PropTypes.bool,
  withRadius: PropTypes.bool,
  small: PropTypes.bool,
};

const defaultProps = {
  color: 'orange',
  alignment: 'left',
};

class Accordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.defaultOpened,
      isOpening: false,
    };
    this.checkState = this.checkState.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.forceOpen && !nextProps.forceOpen) {
      this.checkState();
    }
  }

  checkState() {
    if (!this.state.isOpening) {
      this.setState((prevState) => ({
        isOpen: !prevState.isOpen,
        isOpening: true,
      }));
    }
  }

  render() {
    const {
      title,
      children,
      mod,
      color,
      alignment,
      defaultOpened,
      onOpen,
      onClose,
      isDisabled,
      iconName,
      asBlock,
      withPadding,
      withRadius,
      small,
    } = this.props;

    const wrapperClasses = cx({
      'accordion-simple': true,
      [`accordion-simple--${mod}`]: mod,
      'accordion-simple--block': asBlock,
    });

    const titleClasses = cx({
      'accordion-simple__padding': withPadding,
      'accordion-simple__radius': withRadius,
      'accordion-simple__title': true,
      'accordion-simple__title-small': small,
      [`accordion-simple__title-${color}`]: color,
      [`accordion-simple--icon-${alignment}`]: alignment,
      'accordion-simple__title--open': this.state.isOpen,
    });

    const iconClasses = cx({
      icon: true,
      'icon--arror-rotate': this.state.isOpen,
      [`icon--arrow-${iconName}`]: iconName,
    });

    return (
      <div className={wrapperClasses}>
        <Collapsible
          type="accordion"
          onChange={() => this.setState({ isOpening: false })}
          Title={({ onClick }) => (
            <h3
              onClick={() => {
                if (isDisabled) {
                  return;
                }
                if (!this.state.isOpen && isFunction(onOpen)) {
                  onOpen();
                }
                if (this.state.isOpen && isFunction(onClose)) {
                  onClose();
                }
                onClick();
                this.checkState();
              }}
              className={titleClasses}
            >
              <span className={iconClasses} />
              {title}
            </h3>
          )}
          ButtonClose={() => (null)}
          ButtonOpen={() => (null)}
          ButtonCloseMobile={() => (null)}
          defaultOpened={defaultOpened}
          isOpen={this.state.isOpen}
        >
          {children}
        </Collapsible>
      </div>
    );
  }
}

Accordion.defaultProps = defaultProps;
Accordion.propTypes = propTypes;

export default Accordion;
